module.exports = __webpack_public_path__ + "img/badge-icon-open.f74cc9f4.svg";